import { DBkeys } from "./db-keys";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { LocalStoreManager } from "./local-store-manager.service";
import { Utilities } from "./utilities";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./local-store-manager.service";
var AuthService = /** @class */ (function () {
    function AuthService(router, localStorage) {
        this.router = router;
        this.localStorage = localStorage;
        this.loginUrl = '/accounts/login';
        this.previousIsLoggedInCheck = false;
        this._loginStatus = new Subject();
        this.initializeLoginStatus();
    }
    AuthService.prototype.initializeLoginStatus = function () {
        var _this = this;
        this.localStorage.getInitEvent().subscribe(function () {
            _this.reevaluateLoginStatus();
        });
    };
    AuthService.prototype.gotoPage = function (page, preserveParams) {
        if (preserveParams === void 0) { preserveParams = true; }
        var navigationExtras = {
            queryParamsHandling: preserveParams ? 'merge' : '', preserveFragment: preserveParams
        };
        this.router.navigate([page], navigationExtras);
    };
    AuthService.prototype.gotoHomePage = function () {
        this.router.navigate(['/']);
    };
    AuthService.prototype.redirectLoginUser = function () {
        // const redirect = this.loginRedirectUrl && this.loginRedirectUrl != '/' && this.loginRedirectUrl != ConfigurationService.defaultHomeUrl ? this.loginRedirectUrl : this.homeUrl;
        var redirect = '/';
        this.loginRedirectUrl = null;
        var urlParamsAndFragment = Utilities.splitInTwo(redirect, '#');
        var urlAndParams = Utilities.splitInTwo(urlParamsAndFragment.firstPart, '?');
        var navigationExtras = {
            fragment: urlParamsAndFragment.secondPart,
            queryParams: Utilities.getQueryParamsFromString(urlAndParams.secondPart),
            queryParamsHandling: 'merge'
        };
        this.router.navigate([urlAndParams.firstPart], navigationExtras);
    };
    AuthService.prototype.redirectLogoutUser = function () {
        var redirect = this.logoutRedirectUrl ? this.logoutRedirectUrl : this.loginUrl;
        this.logoutRedirectUrl = null;
        this.router.navigate([redirect]);
    };
    AuthService.prototype.redirectForLogin = function () {
        this.loginRedirectUrl = this.router.url;
        this.router.navigate([this.loginUrl]);
    };
    AuthService.prototype.reLogin = function () {
        if (this.reLoginDelegate) {
            this.reLoginDelegate();
        }
        else {
            this.redirectForLogin();
        }
    };
    // refreshLogin() {
    //     return this.oidcHelperService.refreshLogin()
    //         .pipe(map(resp => this.processLoginResponse(resp, this.rememberMe)));
    // }
    // loginWithPassword(userName: string, password: string, rememberMe?: boolean) {
    //     if (this.isLoggedIn) {
    //         this.logout();
    //     }
    //     return this.oidcHelperService.loginWithPassword(userName, password)
    //         .pipe(map(resp => this.processLoginResponse(resp, rememberMe)));
    // }
    AuthService.prototype.processLoginResponse = function (response, rememberMe) {
        debugger;
        var accessToken = response.token;
        if (accessToken == null) {
            throw new Error('accessToken cannot be null');
        }
        var user = response;
        this.saveUserDetails(user, accessToken, true);
        this.reevaluateLoginStatus(user);
        // return user;
    };
    AuthService.prototype.saveUserDetails = function (user, accessToken, rememberMe) {
        if (rememberMe) {
            this.localStorage.savePermanentData(accessToken, DBkeys.ACCESS_TOKEN);
            // this.localStorage.savePermanentData(refreshToken, DBkeys.REFRESH_TOKEN);
            // this.localStorage.savePermanentData(expiresIn, DBkeys.TOKEN_EXPIRES_IN);
            // this.localStorage.savePermanentData(permissions, DBkeys.USER_PERMISSIONS);
            this.localStorage.savePermanentData(user, DBkeys.CURRENT_USER);
        }
        else {
            this.localStorage.saveSyncedSessionData(accessToken, DBkeys.ACCESS_TOKEN);
            // this.localStorage.saveSyncedSessionData(refreshToken, DBkeys.REFRESH_TOKEN);
            // this.localStorage.saveSyncedSessionData(expiresIn, DBkeys.TOKEN_EXPIRES_IN);
            // this.localStorage.saveSyncedSessionData(permissions, DBkeys.USER_PERMISSIONS);
            this.localStorage.saveSyncedSessionData(user, DBkeys.CURRENT_USER);
        }
        this.localStorage.savePermanentData(rememberMe, DBkeys.REMEMBER_ME);
    };
    AuthService.prototype.saveGuestQuestion = function (question) {
        this.localStorage.savePermanentData(question, DBkeys.guestQuestion);
    };
    AuthService.prototype.getsaveGuestQuestion = function () {
        return this.localStorage.getData(DBkeys.guestQuestion);
    };
    AuthService.prototype.removeGuestQuestion = function () {
        this.localStorage.deleteData(DBkeys.guestQuestion);
    };
    AuthService.prototype.logout = function () {
        this.localStorage.deleteData(DBkeys.ACCESS_TOKEN);
        // this.localStorage.deleteData(DBkeys.REFRESH_TOKEN);
        // this.localStorage.deleteData(DBkeys.TOKEN_EXPIRES_IN);
        // this.localStorage.deleteData(DBkeys.USER_PERMISSIONS);
        this.localStorage.deleteData(DBkeys.CURRENT_USER);
        // this.configurations.clearLocalChanges();
        this.router.navigate(['/']);
        this.reevaluateLoginStatus();
        setTimeout(function () {
            window.location.reload();
        }, 500);
    };
    AuthService.prototype.reevaluateLoginStatus = function (currentUser) {
        var _this = this;
        var user = currentUser || this.localStorage.getDataObject(DBkeys.CURRENT_USER);
        var isLoggedIn = user != null;
        if (this.previousIsLoggedInCheck != isLoggedIn) {
            setTimeout(function () {
                _this._loginStatus.next(isLoggedIn);
            });
        }
        this.previousIsLoggedInCheck = isLoggedIn;
    };
    AuthService.prototype.getLoginStatusEvent = function () {
        return this._loginStatus.asObservable();
    };
    Object.defineProperty(AuthService.prototype, "guestQuestion", {
        get: function () {
            var question = this.localStorage.getDataObject(DBkeys.guestQuestion);
            return question ? question : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "userRole", {
        get: function () {
            var user = this.localStorage.getDataObject(DBkeys.CURRENT_USER);
            this.reevaluateLoginStatus(user);
            return user.role ? user.role : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "userId", {
        get: function () {
            var user = this.localStorage.getDataObject(DBkeys.CURRENT_USER);
            this.reevaluateLoginStatus(user);
            return user.userId ? user.userId : '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "userNumberId", {
        get: function () {
            var user = this.localStorage.getDataObject(DBkeys.CURRENT_USER);
            this.reevaluateLoginStatus(user);
            return user.autoUserId ? user.autoUserId : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "currentUser", {
        get: function () {
            var user = this.localStorage.getDataObject(DBkeys.CURRENT_USER);
            this.reevaluateLoginStatus(user);
            return user;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "currentUserName", {
        get: function () {
            var user = this.localStorage.getDataObject(DBkeys.CURRENT_USER);
            this.reevaluateLoginStatus(user);
            return user.userName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AuthService.prototype, "isLoggedIn", {
        // get userPermissions(): PermissionValues[] {
        //     return this.localStorage.getDataObject<PermissionValues[]>(DBkeys.USER_PERMISSIONS) || [];
        // }
        // get accessToken(): string {
        //     return this.oidcHelperService.accessToken;
        // }
        // get accessTokenExpiryDate(): Date {
        //     return this.oidcHelperService.accessTokenExpiryDate;
        // }
        // get refreshToken(): string {
        //     return this.oidcHelperService.refreshToken;
        // }
        // get isSessionExpired(): boolean {
        //     return this.oidcHelperService.isSessionExpired;
        // }
        get: function () {
            return this.currentUser != null;
        },
        enumerable: true,
        configurable: true
    });
    // get rememberMe(): boolean {
    //     return this.localStorage.getDataObject<boolean>(DBkeys.REMEMBER_ME) == true;
    // }
    AuthService.prototype.setLanguage = function (lang) {
        this.saveLanguage(lang);
    };
    AuthService.prototype.saveLanguage = function (lang) {
        this.localStorage.savePermanentData(lang, DBkeys.LANGUAGE);
    };
    Object.defineProperty(AuthService.prototype, "CurrentLanguage", {
        get: function () {
            var lang = this.localStorage.getDataObject(DBkeys.LANGUAGE);
            if (lang) {
                return lang;
            }
            return 'en';
        },
        enumerable: true,
        configurable: true
    });
    AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.LocalStoreManager)); }, token: AuthService, providedIn: "root" });
    return AuthService;
}());
export { AuthService };
